import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output, ElementRef, Renderer2 } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';


/**
 * <input throttleevent [Event]="'keydown'" (ThrottledEvent)="OnSearch()" />
 */

@Directive({
    selector: '[throttleevent]'
})
export class ThrottleEventDirective implements OnInit, OnDestroy {
    @Input() EventName: string; // Event name, like 'keydown'
    @Input() DebounceTime: number = 500;
    @Input() IgnoreNavigationKeys: boolean = false;
    @Output() ThrottledEvent = new EventEmitter(); //The resulting event that should be handled

    ignoreKeyCodes = [37, 38, 39, 40, 33, 34, 36, 35];

    private eventsQueue = new Subject();
    private subscription: Subscription;
    private eventUnsubscribeFunction: any;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2) { }

    //Handle the event
    OnEvent(event) {
        //Add event to the queue
        this.eventsQueue.next(event);
    }

    //Initialize listener and the new queue
    ngOnInit() {
        //Listen to the requested event
        this.eventUnsubscribeFunction = this.renderer.listen(this.elementRef.nativeElement, this.EventName, (event) => {
            if (!event) return;
            if (this.IgnoreNavigationKeys && event.keyCode) {
                if (this.ignoreKeyCodes.indexOf(event.keyCode) === -1) {
                    this.OnEvent(event);
                }
            } else {
                this.OnEvent(event);
            }
        });

        //Listen to the events queue and throttle them
        this.subscription = this.eventsQueue.pipe(debounceTime(this.DebounceTime)).subscribe(e => this.ThrottledEvent.emit(e));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventUnsubscribeFunction();
    }
}
